import { useSelector } from 'react-redux'

import { makeSelectFeatureSwitches } from '@webapp/core/stores/global'
import { useFeatureFlag } from '@webapp/hooks'

/**
 * Multi-Entity is gated on both the LaunchDarkly flag and the per-account
 * feature switch (sourced from /global), mirroring the backend's
 * `is_multi_entity_enabled()` (flag AND switch).
 */
export const useIsMultiEntityEnabled = (): boolean => {
  const isFlagEnabled = useFeatureFlag('PLAT_4870_MULTI_ENTITY')
  const { multi_entity_enabled: isSwitchEnabled } = useSelector(
    makeSelectFeatureSwitches()
  )

  return Boolean(isFlagEnabled && isSwitchEnabled)
}
